import { RouteConfig } from "vue-router";

const UserRoute: Array<RouteConfig> = [
  {
    path: "/user",
    component: () => import("@/views/ap/user/Index.vue")
  },
  {
    path: "/user/add",
    component: () => import("@/views/ap/user/Add.vue")
  },
  {
    path: "/user/edit/:id",
    component: () => import("@/views/ap/user/Edit.vue")
  }
];

export { UserRoute };
